<div class="chips-filter">
  <a
    [ngClass]="{active: !selectedTeam}"
    (click)="selectedTeam = null"
  >Все</a>
  <a
    [ngClass]="{active: selectedTeam === game.team.id}"
    (click)="selectedTeam = game.team.id"
  >{{ game.team.name }}</a>
  <a
    [ngClass]="{active: selectedTeam === game.competitorTeam.id}"
    (click)="selectedTeam = game.competitorTeam.id"
  >{{ game.competitorTeam.name }}</a>
</div>

<ng-container *ngIf="league.sport.isHockey()">
  <mtg-hockey-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.team.id"
    [team]="game.team"
    [users]="teamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-hockey-game-protocol>
  <mtg-hockey-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.competitorTeam.id"
    [team]="game.competitorTeam"
    [users]="competitorTeamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-hockey-game-protocol>
</ng-container>

<ng-container *ngIf="league.sport.isBasketball()">
  <mtg-basketball-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.team.id"
    [team]="game.team"
    [users]="teamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-basketball-game-protocol>
  <mtg-basketball-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.competitorTeam.id"
    [team]="game.competitorTeam"
    [users]="competitorTeamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-basketball-game-protocol>
</ng-container>

<ng-container *ngIf="league.sport.isVolleyball()">
  <mtg-volleyball-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.team.id"
    [team]="game.team"
    [users]="teamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-volleyball-game-protocol>
  <mtg-volleyball-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.competitorTeam.id"
    [team]="game.competitorTeam"
    [users]="competitorTeamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-volleyball-game-protocol>
</ng-container>

<ng-container *ngIf="league.sport.isFootball()">
  <mtg-football-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.team.id"
    [team]="game.team"
    [users]="teamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-football-game-protocol>
  <mtg-football-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.competitorTeam.id"
    [team]="game.competitorTeam"
    [users]="competitorTeamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-football-game-protocol>
</ng-container>

<ng-container *ngIf="league.sport.isHandball()">
  <mtg-handball-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.team.id"
    [team]="game.team"
    [users]="teamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-handball-game-protocol>
  <mtg-handball-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.competitorTeam.id"
    [team]="game.competitorTeam"
    [users]="competitorTeamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-handball-game-protocol>
</ng-container>

<ng-container *ngIf="league.sport.isRugby()">
  <mtg-rugby-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.team.id"
    [team]="game.team"
    [users]="teamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-rugby-game-protocol>
  <mtg-rugby-game-protocol
    *ngIf="!selectedTeam || selectedTeam === game.competitorTeam.id"
    [team]="game.competitorTeam"
    [users]="competitorTeamGameUsers"
    [gameStatistic]="gameUserStatistic$ | async"
    [game]="game"
    [logs]="gameLogs$ | async"
    class="protocol"
  ></mtg-rugby-game-protocol>
</ng-container>
